module.exports = __webpack_public_path__ + "img/aej1n-66wvl.030.cf8ca47c.png";